// project imports
import config from '../config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], //for active default menu
    fontFamily: config.fontFamily,
    // fontFamily: "Orbitron, sans-serif",
    borderRadius: config.borderRadius,
    opened: true,
    themeMode: "dark",
};

//-----------------------|| CUSTOMIZATION REDUCER ||-----------------------//

/**
 * customizationReducer
 *
 * @summary Manages the customization state for UI settings such as menu, font, border radius, theme mode, and permissions.
 *
 * @description
 * Handles actions to update menu open state, menu visibility, font family, border radius, authorization permissions, and theme mode. Returns the updated customization state based on the dispatched action.
 *
 * @param {Object} state - The current customization state.
 * @param {Object} action - The dispatched Redux action.
 *
 * @returns {Object} The updated customization state.
 *
 * @example
 * const newState = customizationReducer(state, action);
 */
const customizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            const id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.AUTH_MENU:
            return {
                ...state,
                auth_permissions : action.auth_permissions
            };
        case actionTypes.SET_MODE:
            return {
                ...state,
                themeMode : action.themeMode
            };
        default:
            return state;
    }
};

export default customizationReducer;
